/** This export is automatically generated */
export const gitHash = '4d252bd4b';
